import styled from "styled-components";

const SupportSideNavStyles = styled.div`
  border-top: 1px solid rgba(18, 23, 36, 0.2);
  margin-bottom: 40px;
  max-height: 650px;
  padding: ${props => props.noPadding ? '0px 16px !important' : 'initial'};

  ${props => props.theme.media.md} {
    border-top: none;
    min-width: 300px;
    margin-top: 16px;
  }

  .popular-links {
    margin-bottom: 38px;
  }

  .popular-title-container {
    img {
      opacity: .4;
      margin-right: 10px;
    }
    .popular-title {
      display: inline;
      font-size: 16px;
      font-weight: 700;
      line-height: 24px;
      letter-spacing: .02em;
      color: rgba(18, 23, 36, 0.42);
    }
  }

  .all-sections-container {
    margin-top: 10px;
  }
  
  .all-sections-title {
    font-family: Poppins;
    font-size: 16px;
    font-weight: 700;
    line-height: 24px;
    letter-spacing: 0.02em;
    color: rgba(18, 23, 36, 0.42);
  }

  .link-wrapper {
    margin: 20px 0;

    ${props => props.theme.media.lg} {
      margin: 6px 0;
    }

  }

  .link {
    color: rgba(18, 23, 36, 0.91);
    font-family: Poppins;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0.01em;
    font-weight: 400;
  }

  #support-search-bar {
    width: 100%;
    margin: 0;
    margin-bottom: 28px;
    z-index: 2;

    ${props => props.theme.media.md} {
      max-width: 320px;

      .results {
        width: 500px;
        max-width: 33vw;
        max-height: 80vh;
        overflow-y: auto;
      }
    }

    input {
      border: 1px solid rgba(18, 23, 36, 0.2);
      border-radius: 4px;
      box-shadow: none;
    }
  }

`;

export default SupportSideNavStyles;